var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPatientTypePediatric(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 40,
    viewBox: "0 0 32 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8011 5.24457C20.8011 8.13627 18.4483 10.4888 15.5566 10.4888C12.6649 10.4888 10.312 8.13649 10.312 5.24457C10.312 2.35264 12.6649 0 15.5566 0C18.4483 0 20.8011 2.35286 20.8011 5.24457Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3465 39.5445C23.042 39.8792 22.6063 40.0453 22.1809 39.9893C21.8593 39.9471 21.6225 39.7932 21.4577 39.5189C21.1921 39.0775 21.1093 38.3189 21.2183 37.3257C21.3618 36.0208 21.8303 34.2957 22.6112 32.1988C22.6739 32.0301 22.6276 31.8405 22.4946 31.7197L19.4834 28.991L22.5433 25.1187C23.4977 25.5048 26.5768 26.9603 27.353 29.9105C28.0608 32.6016 26.7129 35.843 23.3465 39.5445Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.93192 37.3256C10.0411 38.3188 9.95818 39.0771 9.69255 39.5188C9.52773 39.793 9.2913 39.9469 8.96936 39.9892C8.54379 40.0452 8.10814 39.879 7.80378 39.5444C4.43941 35.845 3.091 32.6056 3.79597 29.9158C4.17542 28.4679 5.13863 27.206 6.65892 26.1653C7.45948 25.6171 8.21361 25.2773 8.60705 25.1187L11.6669 28.991L8.65577 31.7197C8.52242 31.8405 8.4763 32.0301 8.53913 32.1988C9.31994 34.2956 9.78869 36.0207 9.93192 37.3256Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9564 22.0493V24.4431L18.6707 28.6014H12.4799L9.19189 24.4402V22.0493H21.9564Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.1029 21.8333C31.0438 22.4064 30.7333 22.9156 30.2511 23.2312C29.5013 23.7213 28.4972 23.6174 27.8639 22.984L22.7069 17.8278C22.5813 17.702 22.3923 17.6643 22.2279 17.7325C22.0636 17.8008 21.9565 17.9609 21.9565 18.1386V21.1703H9.19169V18.1383C9.19169 17.9605 9.08491 17.8003 8.92064 17.7323C8.75636 17.6641 8.56723 17.7018 8.44147 17.8276L3.25137 23.0177C2.61748 23.6516 1.61281 23.7557 0.862596 23.2648C0.380284 22.9497 0.0694113 22.4401 0.0102751 21.867C-0.0490781 21.2938 0.150683 20.7315 0.558235 20.324L6.94125 13.9406C8.60065 12.2812 10.8068 11.3672 13.154 11.3672H17.9838C20.3283 11.3672 22.5329 12.2794 24.1921 13.9364L30.5554 20.2906C30.9623 20.6982 31.162 21.2602 31.1029 21.8333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientTypePediatric);
export default __webpack_public_path__ + "static/media/patient_type_pediatric.9ace56f501326d37625f7cebf114a5cf.svg";
export { ForwardRef as ReactComponent };